<template>
  <EcsDashboardSupervisorSideBar v-if="isSupervisor && $featuresManager.supervisorFeatures.enable" />
  <EcsAgentSideBar v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import EcsDashboardSupervisorSideBar from '@/components/ecs-app-side-bar/ecs-dashboard-side-bar/ecs-supervisor-side-bar/EcsDashboardSupervisorSideBar';
import EcsAgentSideBar from '@/components/ecs-app-side-bar/ecs-dashboard-side-bar/ecs-agent-side-bar/EcsAgentSideBar';

export default {
  name: 'EcsDashboardSideBar',

  components: { EcsDashboardSupervisorSideBar, EcsAgentSideBar },

  computed: mapGetters('AGENT', ['isSupervisor'])
};
</script>
